import React, { useState }  from 'react'
import axios from 'axios'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
const sample = [{speaker:'You',msg:'How much is Intel Core Ultra 200S?'},{speaker:'AI',msg:'The Intel Core Ultra 200S costs between $299 and $619.'}]
export default function LlmCopilot() {
    const [loadingMsg, setLoadingMsg]= useState(false)
    const [script, setScript]= useState(sample)
    const [userInput, setUserInput] = useState({question:'How much is Intel Core Ultra 200S?'})
    const onChange2Input = ({ currentTarget: x }) => { setUserInput({ ...userInput, [x.name]: x.value }) }
    const onClick2Rag1=async()=>{
        script.push({speaker:'You',msg:userInput.question})
        setLoadingMsg(true)
        try {
            const { data: res } = await axios.post(`${APIURL}/llm/tools`,userInput)
            console.log(res)
            setLoadingMsg(false)
            script.push({speaker:'AI','msg':res['answer']})
        } catch (err) {
            console.log(err)
        }
    }
    return (
        <>
        <p className='text-[8px] mt-[4px]'>
        <b>Price list:</b><br/>
        <table className='border-separate border-spacing-2 border'>
        <tr><td>Intel Core Ultra 200S</td><td>$299 to $619</td></tr>
        <tr><td>Intel 14th Gen</td><td>$90 to $432</td></tr>
        <tr><td>AMD Ryzen 9000-Series</td><td>$229 to $869</td></tr>
        <tr><td>AMD Ryzen 7000-Series</td><td>$178 to $739</td></tr>
        <tr><td>AMD Ryzen 5000-Series</td><td>$107 to $337</td></tr>
        </table>
        </p>
        <p className='text-[8px] sample-format-lg'>
        <b>Sample Question to Ask</b><br/>
        How much is Intel Core Ultra 200S?<br/>
        </p>
        <div className='mt-[2px] flex'>
        <input className='pl-[2px] border border-gray-800 w-full md:w-80 mr-[2px]'  name='question' type='text' defaultValue='How much is Intel Core Ultra 200S?' onChange={onChange2Input}/>
        <button className='bg-gray-800 hover:bg-gray-700 h-auto pl-[8px] pr-[8px] text-white text-[12px]' onClick={onClick2Rag1}>Ask to AI</button>
        </div>
        <div className='text-left'>
        <>{script.map((x)=><>{x.speaker}: {x.msg}<br/></>)}</>
        {loadingMsg?<p className='flex text-xs'>Please wait for 5seconds<span className='primary-loader1'>.</span><span className='primary-loader2'>.</span><span className='primary-loader3'>.</span></p>:''}
        </div>
        </>
    )
}